import { useEffect, useState } from 'react';

let activeTours = 0;
const listeners = new Set<() => void>();

const notify = () => listeners.forEach((listener) => listener());

export function markTourActive() {
  activeTours += 1;
  notify();
  return () => {
    activeTours -= 1;
    notify();
  };
}

export function useIsTourActive() {
  const [isActive, setIsActive] = useState(() => activeTours > 0);

  useEffect(() => {
    const update = () => setIsActive(activeTours > 0);
    update();
    listeners.add(update);
    return () => {
      listeners.delete(update);
    };
  }, []);

  return isActive;
}
